import { useState } from 'preact/hooks';
import { joinFamily } from '../../data/membership';
import { mapJoinError } from '../errors';

export function JoinFamily(props: { token: string; onJoined?: () => void }) {
  const [firstName, setFirstName] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [firstError, setFirstError] = useState<string | null>(null);

  async function doJoin() {
    setError(null);
    const f = firstName.trim();
    setFirstError(!f ? 'Enter your first name' : null);
    if (!f) return;
    setBusy(true);
    try {
      await joinFamily(props.token, f);
      props.onJoined?.();
    } catch (e: any) {
      console.error('[join family]', e);
      setError(mapJoinError(e));
    } finally {
      setBusy(false);
    }
  }

  return (
    <section class="install-safe">
      <div class="install-card">
        <h2 class="install-title">Join your partner</h2>
        <div class="install-body">
          <label class="form-label" for="first">Your first name</label>
          <input
            id="first"
            class="form-input"
            value={firstName}
            onInput={(e) => setFirstName((e.target as HTMLInputElement).value)}
            placeholder="First name"
            autocomplete="given-name"
          />
          <div class="install-actions" style="margin-top:12px;">
            <button
              class="primary-btn"
              type="button"
              disabled={busy || !firstName.trim()}
              onClick={() => void doJoin()}
            >
              {busy ? 'Joining…' : 'Join'}
            </button>
          </div>
          {error && <div class="tiny-banner error" role="alert">{error}</div>}
          {firstError && <div class="tiny-banner error" role="alert">{firstError}</div>}
        </div>
      </div>
    </section>
  );
}

